'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n    margin-bottom: 10px;\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);\n    border-radius: 2px;\n    border: ', ';\n'], ['\n    margin-bottom: 10px;\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);\n    border-radius: 2px;\n    border: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 0;\n  display: flex;\n  width: 100%;\n  background: #FFFFFF;\n  border: none;\n'], ['\n  padding: 0;\n  display: flex;\n  width: 100%;\n  background: #FFFFFF;\n  border: none;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 75px;\n  padding-top: 20px;\n  float: left;\n  font-family: ', ';\n  font-size: 12px;\n  color: #6E4D40;\n  letter-spacing: 0;\n  line-height: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  img {\n    width: 25px;\n    padding-bottom: 6px;\n  }\n'], ['\n  width: 75px;\n  padding-top: 20px;\n  float: left;\n  font-family: ', ';\n  font-size: 12px;\n  color: #6E4D40;\n  letter-spacing: 0;\n  line-height: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  img {\n    width: 25px;\n    padding-bottom: 6px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n    width: calc(100% - 75px);\n    padding: 20px 20px 20px 0;\n'], ['\n    width: calc(100% - 75px);\n    padding: 20px 20px 20px 0;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n    text-align: left;\n    padding-bottom: 16px;\n    font-family: ', ';\n    font-size: 20px;\n    color: #3E2723;\n    letter-spacing: 0;\n'], ['\n    text-align: left;\n    padding-bottom: 16px;\n    font-family: ', ';\n    font-size: 20px;\n    color: #3E2723;\n    letter-spacing: 0;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n    font-family: ', ';\n    text-align: left;\n    font-size: 12px;\n    color: #3E2723;\n    letter-spacing: 0;\n    line-height: 20px;\n'], ['\n    font-family: ', ';\n    text-align: left;\n    font-size: 12px;\n    color: #3E2723;\n    letter-spacing: 0;\n    line-height: 20px;\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n    font-family: ', ';\n    color: #6E4D40;\n    padding-top: 20px;\n'], ['\n    font-family: ', ';\n    color: #6E4D40;\n    padding-top: 20px;\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

var _commonWebLocalization = require('../../localization/commonWebLocalization');

var _commonWebLocalization2 = _interopRequireDefault(_commonWebLocalization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var CardStyled = _styledComponents2.default.div(_templateObject, function (props) {
    return props.addBorder ? '1px solid #C5B3AF' : '1px solid #EFEFEF';
});

var ButtonStyled = _styledComponents2.default.button(_templateObject2);

var PinSectionStyled = _styledComponents2.default.div(_templateObject3, _styledComponentsHelper.fontFamilies.bold);

var InfoContainer = _styledComponents2.default.div(_templateObject4);

var TitleStyled = _styledComponents2.default.div(_templateObject5, _styledComponentsHelper.fontFamilies.bold);

var InfoStyled = _styledComponents2.default.div(_templateObject6, _styledComponentsHelper.fontFamilies.regular);

var Hours = _styledComponents2.default.div(_templateObject7, _styledComponentsHelper.fontFamilies.bold);

var Card = function (_Component) {
    _inherits(Card, _Component);

    function Card() {
        _classCallCheck(this, Card);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Card.prototype.render = function render() {
        var location = this.props.location;
        var index = this.props.index;
        var distance = (Math.round(parseFloat(location.distance) * 10) / 10).toFixed(1) + ' mi';
        distance = distance === '0.0 mi' ? '' : distance;

        var hours = !!location.hours ? _react2.default.createElement(
            Hours,
            null,
            _commonWebLocalization2.default.get('card_hours_open'),
            location.hours
        ) : '';

        return _react2.default.createElement(
            CardStyled,
            { id: "ada-result-" + index, addBorder: this.props.hasSelectionBorder },
            _react2.default.createElement(
                ButtonStyled,
                { onClick: this.props.selectHandler },
                _react2.default.createElement(
                    PinSectionStyled,
                    { className: 'distance', id: "find-distance-" + index },
                    _react2.default.createElement('img', { className: 'marker-icon', src: this.props.pinUrl, alt: '', role: 'icon' }),
                    distance
                ),
                _react2.default.createElement(
                    InfoContainer,
                    { id: "find-description-" + index },
                    _react2.default.createElement(
                        TitleStyled,
                        null,
                        location.title
                    ),
                    _react2.default.createElement(
                        InfoStyled,
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            '#',
                            location.id
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            location.address1
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            location.address2
                        ),
                        hours
                    )
                )
            )
        );
    };

    return Card;
}(_react.Component);

Card.propTypes = {
    location: _propTypes2.default.object.isRequired,
    pinUrl: _propTypes2.default.string.isRequired,
    index: _propTypes2.default.number,
    selectHandler: _propTypes2.default.func,
    hasSelectionBorder: _propTypes2.default.bool
};

Card.defaultProps = {
    index: 1,
    selectHandler: function selectHandler() {}
};

exports.default = Card;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/Card/index.js
// module id = 835
// module chunks = 0